/**
 * Create/update saved stats filter preset + optional share in one flow.
 * For Media Devoted | Created By Ciro Autiero
 */

import type {
  CreateSavedFilterPayload,
  FilterCondition,
  SavedFilter,
  UpdateSavedFilterPayload,
} from '@/features/smswiser-campaigns/types/saved-filter.types';
import type { SaveFilterSubmitData } from '../modals';

import { buildSavedFilterDatePayload } from './buildSavedFilterDatePayload';

interface MutateSave {
  mutateAsync: (p: CreateSavedFilterPayload) => Promise<SavedFilter>;
}

interface MutateUpdate {
  mutateAsync: (p: UpdateSavedFilterPayload) => Promise<SavedFilter>;
}

interface MutateShare {
  mutateAsync: (p: { filterId: string; userIds: string[] }) => Promise<void>;
}

export async function persistSavedStatsFilter(
  data: SaveFilterSubmitData,
  filters: FilterCondition[],
  editingPreset: SavedFilter | null,
  saveFilter: MutateSave,
  updateFilter: MutateUpdate,
  shareFilter: MutateShare,
): Promise<string> {
  const { shareUserIds, name, color, tabs } = data;
  const dateFields = buildSavedFilterDatePayload(data);
  const body = { name, color, tabs, filters, ...dateFields };
  let filterId: string;
  if (editingPreset) {
    await updateFilter.mutateAsync({ id: editingPreset.id, ...body });
    filterId = editingPreset.id;
  } else {
    const created = await saveFilter.mutateAsync(body);
    filterId = created.id;
  }
  if (shareUserIds.length > 0) {
    await shareFilter.mutateAsync({ filterId, userIds: shareUserIds });
  }
  return filterId;
}
